import React, { useEffect, useLayoutEffect, useState } from "react";
import OrderService from "../../services/OrderService";
import styled from "styled-components";
import { IonHeader, IonIcon, IonSpinner } from "@ionic/react";
import Page from "../../components/Page";
import xookMenuLogo from "../../assets/ko.png";
import { chevronBackOutline } from "ionicons/icons";
import { useHistory } from "react-router";
import withNav from "../../utils/hoc/withNav";
import { PaymentStatusMap, orderStatusMap, taskStatusMap } from "../../config";
import { isEmpty } from "../../utils/objects";
import { connect } from "react-redux";
import { renderCustomisations } from "../../utils/parsers/customisations";
import Analytics, { TRACK_PAGE_CATEGORIES } from "../../lib/anayltics";
import { uptilTwoDecimalPlaces } from "../../utils/misc";
import { renderDishContents } from "../../utils/parsers/dishContents";

const PageHeader = styled(IonHeader)`
	position: fixed;
	margin: 0 0 0 0;
	background: ${({ theme }) => theme.colors.main.background};
	font-family: inherit;
	font-style: normal;
	font-size: 20px;
	display: flex;
	align-items: center;
	padding: 1.5rem 1rem;
	border: none;
	box-shadow: none;
	&:after {
		background-image: none;
	}
	gap: 0.5rem;
`;

const Container = styled.div`
	display: flex;
	flex-direction: column;
	height: max-content;
	width: 100%;
`;

const BackButton = styled.div``;

const BackButtonImg = styled(IonIcon)`
	width: 24px;
	height: 24px;
	color: #fff;
	/* Icon alignment */
	margin-left: -5px;
	margin-top: 3px;
`;

const HelpButton = styled(IonIcon)`
	width: 20px;
	height: 20px;
	margin-left: auto;
`;

const SmallSpace = styled.div`
	margin: 5rem 0 0 0;
`;

const PageTitle = styled.div`
	font-style: normal;
	font-weight: 500;
	font-size: 20px;
	letter-spacing: 0px;
	display: flex;
	justify-content: center;
`;

const Title = styled.div`
	font-style: normal;
	font-weight: 500;
	font-size: 16px;
	letter-spacing: 0px;
	text-align: left;
	width: 100%;
`;

const OrderDetailsContainer = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	width: 100%;
	margin: 0.2rem 0 0 0;
`;

const OrderId = styled.div`
	font-weight: 500;
	font-size: 18px;
	color: #f2f2f2;
`;

const OrderItems = styled.div`
	display: flex;
	flex-direction: column;
	height: max-content;
	width: 100%;
`;

const OrderStatus = styled.div<any>`
	width: max-content;
	padding: 0 0.5rem;
	min-width: 86px;
	height: 27px;
	font-weight: 500;
	font-size: 10px;
	border: 1px solid ${(props) => props.color};
	color: ${(props) => props.color};
	display: flex;
	justify-content: center;
	align-items: center;
`;

const KioskDetails = styled.div`
	display: block;
	overflow: hidden;
	width: 100%;
	font-weight: 400;
	font-size: 11px;
	color: #ffffff;
	align-self: flex-start;
	margin: 0.2rem 0 0 0;
	text-align: left;
`;

const KioskId = styled.div`
	display: block;
	overflow: hidden;
	width: 100%;
	font-weight: 400;
	font-size: 11px;
	color: #ffffff;
	align-self: flex-start;
	margin: 0.2rem 0 0 0;
	text-align: left;
`;

const Card = styled.div<any>`
	background: #737373;
	height: max-content;
	width: 100%;
	gap: ${(props) => props.gap};
	display: flex;
	flex-direction: column;
	padding: 1rem;
	border-radius: 6px;
	margin: ${(props) => props.margin};
`;

const Dish = styled.div<any>`
	display: flex;
	flex-direction: row;
	width: 100%;
	height: max-content;
	overflow: hidden;
	border-radius: 6px;
`;

const BrandDetails = styled.div`
	display: flex;
	align-items: flex-start;
	height: 100%;
	width: max-content;
	padding: 0 1rem 0 0;
`;

const BrandLogo = styled.img`
	width: 34px;
	height: 34px;
	border-radius: 4px;
`;

const DishDetails = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	height: max-content;
`;

const CenteredRow = styled.div`
	display: flex;
	width: max-content;
	height: max-content;
	align-items: center;
	width: 40%;
`;

const DishTitle = styled.div`
	font-weight: 500;
	font-size: 18px;
	height: max-content;
	color: #ffffff;
	text-align: left;
	line-height: 21px;
`;

const Head1 = styled.div`
	font-weight: 500;
	font-size: 18px;
	height: max-content;
	color: #ffffff;
	text-align: left;
	line-height: 21px;
`;

const Head2 = styled.div`
	font-weight: 400;
	font-size: 14px;
	height: max-content;
	color: #ffffff;
	text-align: left;
	line-height: 21px;
`;

const Para1 = styled.div<any>`
	font-weight: 400;
	font-size: 12px;
	text-align: left;
	color: #e8e8e8;
`;

const DishStatus = styled.div<any>`
	font-weight: 600;
	font-size: 14px;
	color: ${(props) => props.color};
	text-align: center;
	color: #d6d6d6;
`;

const Arrow = styled(IonIcon)`
	width: 18px;
	height: 18px;
	color: #f2f2f2;
	margin: 0 0 0 0;
`;

const Line = styled.div`
	margin: 0.5rem 0 0 0;
	height: 5px;
	width: 40px;
	background: #ffcc00;
`;

const Row = styled.div<any>`
	display: flex;
	justify-content: space-between;
	align-items: ${(props) => props.alignItems || "center"};
	width: 100%;
	margin: ${(props) => props.margin || "0 0 0 0"};
	gap: ${(props) => props.gap || "0 0 0 0"};
`;

const Column = styled.div<any>`
	display: flex;
	flex-direction: column;
	width: ${(props) => props.width || "100%"};
	margin: ${(props) => props.margin || "0rem 0 0 0"};
	gap: ${(props) => props.gap || "0 0 0 0"};
	transition: 300ms all ease-in-out;
`;

const BillingContent = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	color: #e8e8e8;
	font-size: 16px;
	font-weight: 500;
	line-height: normal;
	width: max-content;
	height: max-content;
`;

const BillingSubContent = styled.div`
	color: #d6d6d6;
	font-size: 11px;
	font-style: normal;
	font-weight: 400;
	line-height: normal;
`;

const Seperator = styled.div<any>`
	border-top: 1px dotted #f2f2f2;
	width: 100%;
	margin: ${(props) => props.margin || "0.5rem 0"};
`;

const DiscountedPrice = styled.div<any>`
	font-weight: 400;
	font-size: 14px;
	color: #f2f2f2;
	text-decoration: line-through;
`;

const Time = styled.div`
	color: #d6d6d6;
	text-align: right;
	font-family: Roboto;
	font-size: 12px;
	font-style: normal;
	font-weight: 400;
	line-height: normal;
`;

const ContentSpacingBig = styled.div`
	margin: 1.5rem 0 0 0;
`;

const ContentSpacingSmall = styled.div`
	margin: 1rem 0 0 0;
`;

const ContentSpacingExtaSmall = styled.div`
	margin: 0.5rem 0 0 0;
`;

const Center = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	height: 100%;
	width: 100%;
`;

const OrderDetails = (props: any) => {
	const { orderId } = props.match.params;

	const history = useHistory();

	const [orderDetails, setOrderDetails] = useState({});
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState(false);

	async function getOrderDetails() {
		setLoading(true);
		const response = await OrderService.getOrderDetails(orderId);
		setLoading(false);
		const { data, error } = response;
		if (data) {
			setOrderDetails(data);
		}
		if (error) {
			setError(error);
		}
	}

	function goBack() {
		history.goBack();
	}

	function onPageLoad() {
		Analytics.trackPage(TRACK_PAGE_CATEGORIES.PAGE_LOAD, "Order Details");
		getOrderDetails();
	}

	useEffect(() => {
		onPageLoad();
	}, []);

	useLayoutEffect(() => {
		if (orderDetails) {
			const script = document.createElement("script");
			script.src = "https://embed.typeform.com/next/embed.js";
			script.async = true;
			script.id = "form-script";
			document.body.appendChild(script);
		}

		return () => {
			const scriptElement = document.getElementById("form-script");
			if (scriptElement) {
				document.body.removeChild(scriptElement);
			}
		};
	}, [orderDetails]);

	function renderOrderItems(orderItems: any, currency: any, brandDetails: any) {
		let renderData: any = [];
		if (orderItems.length) {
			orderItems.forEach((dish: any) => {
				const { itemDetails, fullfillmentDetails } = dish;
				const { title, price, brandId, finalPrice } = itemDetails;
				const { status } = fullfillmentDetails;
				const statusConfig = taskStatusMap?.[status];
				if (!statusConfig) return;

				const { statusMessage } = statusConfig;
				let brandImage = xookMenuLogo;

				//Backward compatibility
				if (brandDetails) {
					const brandData = brandDetails.find((brand: any) => brand.id === brandId);
					if (brandData) {
						const { brandCms } = brandData;
						brandImage = brandCms?.brandLogo || "";
					}
				}
				const finalAmount = finalPrice || price || 0;

				renderData.push(
					<Dish>
						<BrandDetails>
							<BrandLogo src={brandImage} />
						</BrandDetails>
						<DishDetails>
							<Row>
								<DishTitle>{title}</DishTitle>
								<DishStatus>{statusMessage}</DishStatus>
							</Row>
							<Line />
							<Row margin="0.5rem 0 0 0">
								<Column width="80%">{renderDishContents({ dishData: itemDetails })}</Column>
								<Head2>
									{currency} {uptilTwoDecimalPlaces(finalAmount)}
								</Head2>
							</Row>
						</DishDetails>
					</Dish>
				);
			});
		}
		return renderData;
	}

	function renderCoupons(offers: any, couponOffer: any, currency: string) {
		let renderData = [];

		//Backward Compatible
		if (couponOffer?.length) {
			for (const coupon of couponOffer) {
				const { saving, offerCode, title } = coupon;
				if (offerCode || title) {
					renderData.push(
						<Row>
							<BillingSubContent>{title || offerCode}</BillingSubContent>
							<BillingSubContent>
								{currency} {uptilTwoDecimalPlaces(saving)}
							</BillingSubContent>
						</Row>
					);
				}
			}
			return renderData;
		}

		for (const offerGroup in offers) {
			const offerGroupData = offers[offerGroup];
			for (const offer in offerGroupData) {
				const { saving, offerCode, title } = offerGroupData[offer] || {};
				renderData.push(
					<Row margin="0.25rem 0 0 0">
						<BillingSubContent>{title || offerCode}</BillingSubContent>
						<BillingSubContent>
							{currency} {uptilTwoDecimalPlaces(saving)}
						</BillingSubContent>
					</Row>
				);
			}
		}

		return renderData;
	}

	function renderOrderDetails(orderDetails: any) {
		if (loading || error) return;

		if (!orderDetails || isEmpty(orderDetails)) return;

		const {
			_id,
			status,
			restaurantId,
			restaurantName,
			price,
			finalPrice,
			items,
			paymentDetails,
			discount,
			taxAmount,
			cartPrice,
			brandDetails,
			createdAt,
			offers,
			couponOffer,
			taxEntity,
		} = orderDetails;
		const orderStatusConfig = orderStatusMap?.[status];
		const createdAtDate = new Date(createdAt).toLocaleString("en-US");
		const [date, time] = createdAtDate.split(",");

		if (!orderStatusConfig) {
			setError(true);
			return;
		}

		const { color, statusMessage } = orderStatusConfig;
		const { paymentStatus } = paymentDetails;
		const paymentStatusConfig = PaymentStatusMap?.[paymentStatus]
		//Backward compatibility
		let currencySymbol = orderDetails?.currencySymbol || "";
		const tax = taxAmount || taxEntity?.taxAmount || 0;

		return (
			<>
				<OrderDetailsContainer>
					<OrderId>{_id}</OrderId>
					<OrderStatus color={color}>{statusMessage}</OrderStatus>
				</OrderDetailsContainer>
				<Row margin="0.7rem 0 0 0">
					<Column gap="10px 0 0 0">
						<KioskDetails>{restaurantName}</KioskDetails>
						<KioskId>Kiosk ID : {restaurantId}</KioskId>
					</Column>
					<Column gap="10px 0 0 0">
						<Time>{date}</Time>
						<Time>{time}</Time>
					</Column>
				</Row>

				<ContentSpacingBig />

				<div data-tf-live="01KEWCEX12B3SJ9KSP1S1T70XV" data-tf-hidden={`order_id=${_id},src=app_details_page`}></div>

				<ContentSpacingBig />
				<Title>Items</Title>
				<ContentSpacingExtaSmall />
				<Card gap={"2rem 0"}>{renderOrderItems(items, currencySymbol, brandDetails)}</Card>

				{paymentStatusConfig?.isVisible && paymentDetails?.[paymentStatusConfig?.keyToRead] ? (
					<>
						<ContentSpacingBig />
						<Title>Refund Status</Title>
						<ContentSpacingExtaSmall />
						<Card margin="0 0 0 0">
							<Row alignItems="flex-start">
								<Column gap="0.5rem 0" width="70%">
									<Head1>{paymentStatusConfig?.head}</Head1>
								</Column>
								<Head1>
									{currencySymbol} {uptilTwoDecimalPlaces(paymentDetails[paymentStatusConfig?.keyToRead])}
								</Head1>
							</Row>
						</Card>
					</>
				) : (
					""
				)}

				<ContentSpacingBig />
				<Title>Bill Details</Title>
				<ContentSpacingExtaSmall />

				<Card gap="0.5rem 0" margin="0 0 0 0">
					<Row>
						<BillingContent>Cart Total</BillingContent>
						<BillingContent>
							{currencySymbol} {uptilTwoDecimalPlaces(cartPrice)}
						</BillingContent>
					</Row>
					{typeof discount !== "undefined" ? (
						<Row>
							<BillingContent>Discount</BillingContent>
							<BillingContent>
								{currencySymbol} {uptilTwoDecimalPlaces(discount)}
							</BillingContent>
						</Row>
					) : (
						""
					)}
					{renderCoupons(offers, couponOffer, currencySymbol)}
					<Row>
						<BillingContent>Tax</BillingContent>
						<BillingContent>{`${currencySymbol} ${uptilTwoDecimalPlaces(tax)}`}</BillingContent>
					</Row>
					<Seperator />
					<Row>
						<BillingContent>To Pay</BillingContent>
						<BillingContent>
							{currencySymbol} {uptilTwoDecimalPlaces(price)}
						</BillingContent>
					</Row>
				</Card>
			</>
		);
	}

	return (
		<Page>
			<PageHeader>
				<BackButton onClick={goBack}>
					<BackButtonImg src={chevronBackOutline} />
				</BackButton>
				<PageTitle>Order Details</PageTitle>
			</PageHeader>
			<SmallSpace />
			<Container>{renderOrderDetails(orderDetails)}</Container>
			{loading ? (
				<Center>
					{" "}
					<IonSpinner name="dots"></IonSpinner>{" "}
				</Center>
			) : (
				""
			)}
			{error ? (
				<Center>
					<PageTitle>{error}</PageTitle>
				</Center>
			) : (
				""
			)}
		</Page>
	);
};

//Redux mapping
const mapStateToProps = (state: any) => {
	const {
		Food: { ingredientDetails },
		Xook: { currency },
	} = state;
	return { ingredientDetails, currency };
};

const mapDispatchToProps = (dispatch: any) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(withNav(OrderDetails));
